import { PrepaidCardImage } from '@models/prepaidCard';
import { useContext, useMemo } from 'react';

import PpCardListContext from '../context/PpCardListContext';

const GRID_COUNT = 6;

function usePpCardPages() {
    const { data } = useContext(PpCardListContext);
    const { images } = data;
    return useMemo(() => {
        const result: PrepaidCardImage[][] = [[]];
        for (let i = 0; i < images.length; i += 1) {
            if (result[result.length - 1].length === GRID_COUNT) {
                result.push([]);
            }
            result[result.length - 1].push(images[i]);
        }
        return result;
    }, [images]);
}

export default usePpCardPages;
